import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useActiveVisitorsQuery } from '../../queries/useActiveVisitorsQuery';
import { isAvailable } from './types';
dayjs.extend(duration);
dayjs.extend(relativeTime);
const REFETCH_INTERVAL_TIME = 10_000;
export const useActiveVisitors = () => {
    // NOTE: it should be rendered only when initial visitors count is positive
    const [showVisitors, setShowVisitors] = useState(false);
    const { activeVisitorsQuery } = useActiveVisitorsQuery(undefined, {
        refetchInterval: showVisitors ? REFETCH_INTERVAL_TIME : undefined,
    });
    const visitorsCount = isAvailable(activeVisitorsQuery.data)
        ? activeVisitorsQuery.data.activeUsers
        : 0;
    useEffect(() => {
        if (activeVisitorsQuery.isFetched) {
            setShowVisitors(!!visitorsCount);
        }
    }, [activeVisitorsQuery.isFetched, visitorsCount]);
    const period = (() => {
        if (isAvailable(activeVisitorsQuery.data)) {
            const humanizedPeriod = dayjs.duration(activeVisitorsQuery.data.period).humanize();
            return humanizedPeriod.startsWith('a ') ? humanizedPeriod.replace('a ', '') : humanizedPeriod;
        }
    })();
    return {
        isEnabled: activeVisitorsQuery.data?.type === 'AVAILABLE' && showVisitors,
        visitorsCount,
        period,
    };
};
